import React from 'react';
import { Dialog, DialogTitle, DialogDescription, DialogFooter } from './ui';

export interface ConfirmationProps {
  okLabel?: string;
  cancelLabel?: string;
  title?: string;
  confirmation?: string;
  show: boolean;
  proceed?: () => void;
  cancel?: () => void;
  dismiss?: () => void;
  showOk?: boolean;
}

export const Confirmation: React.FC<ConfirmationProps> = ({
  okLabel = 'Yes',
  cancelLabel = 'No',
  title = 'Delete Confirm',
  confirmation,
  show,
  proceed,
  dismiss,
  cancel,
  showOk = true,
}) => {
  return (
    <Dialog open={show} onOpenChange={(open) => { if (!open) dismiss?.(); }}>
      <DialogTitle>{title}</DialogTitle>
      {confirmation && <DialogDescription>{confirmation}</DialogDescription>}
      <DialogFooter>
        {showOk && (
          <button
            onClick={proceed}
            className="bg-primary text-white hover:bg-primary/90 rounded-lg px-5 py-2 text-sm font-medium transition-colors"
          >
            {okLabel}
          </button>
        )}
        <button
          onClick={cancel}
          className="px-5 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          {cancelLabel}
        </button>
      </DialogFooter>
    </Dialog>
  );
};

export default Confirmation;
